import { React, Typography, Backdrop, CircularProgress  } from '../../utils/globalImports';

interface CustomBackdropProps {
  open: boolean;
  message?: string;
  color?: string;
  size?: number;
  sx?: any;
}

const CustomBackdrop: React.FC<CustomBackdropProps> = ({
  open,
  message = '',
  color = '#1e66ab',
  size = 80,
  sx
}) => {
  return (
    <Backdrop
      sx={{
        color: color,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        ...sx,
      }}
      open={open}
    >
      <CircularProgress color="inherit" size={size} />
      <Typography variant="h6" sx={{ color: color }}>
        {message}
      </Typography>
    </Backdrop>
  );
};

export default CustomBackdrop;
